module.exports = __webpack_public_path__ + "static/media/bg6.ade87d0d.jpg";